import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  faPlus,
  faMinus,
  faCircle,
  faPencil,
  faTrashCan,
  faTrash,
  faFloppyDisk,
  faCancel,
  faMagnifyingGlass,
  faSearch,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

import { FormControl } from "@angular/forms";
import { NotifierService } from "angular-notifier";
import { InvoiceService } from "src/app/services/autopac/invoice.service";

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {

  titleSelect: string | undefined;
  coeType: string | undefined;
  modeContac: string | undefined;
  carType: string | undefined;
  discount: string | undefined;
  paymentType: string | undefined;
  loanPeriod: string | undefined;
  dealrName: string | undefined;
  insuranceCompany: string | undefined;
  titles: string[] = ["MR", "MRS", "MISS", "M/S", "MMDM", "DR", "MS"];
  coes: string[] = ["Bidding", "Own COE", "Immediate E"];
  cartypes: string[] = [
    "Standard",
    "Off Peak Car(OPC)",
    "Compressed Natural Gas (CNG)",
    "CNG OPC",
    "OPC",
  ];
  modscontac: string[] = [
    "REFERRAL",
    "REPEAT",
    "WALK-IN",
    "POSTALE",
    "ONLINE SALES",
  ];
  discounts: string[] = ["500", "700", "1000"];
  paymenttypes: string[] = [
    "AIG OTHERS",
    "AIG IN HOUSE",
    "AXA INSURANCE OTHERS",
    "AXA INSURANCE IN-HOUSE",
    "LIBERTY INSURANCE IN-HOUSE",
    "MSIG INSURANCE IN-HOUSE",
    "NTUC INCOME OTHERS",
    "NTUC INCOME IN-HOUSE",
    "OWN INSURANCE",
  ];
  roadTaxDurations = [
    { value: "0", label: "0 month" },
    { value: "Six", label: "6 months" },
    { value: "Twelve", label: "12 months" },
  ];
  dealernames: string[] = [
    "No Trade In",
    "BOEKI AUTO & MARINE PTE LTD",
    "KMPL USED CAR DIVISION",
  ];

  faPlus = faPlus;
  faMinus = faMinus;
  faCircle = faCircle;
  faPencil = faPencil;
  faTrashCan = faTrashCan;
  faFloppyDisk = faFloppyDisk;
  faCancel = faCancel;
  faTrash = faTrash;
  faMagnifyingGlass = faMagnifyingGlass;
  faSearch = faSearch
  faTriangleExclamation = faTriangleExclamation

  textInput: string = "";
  required: boolean = true;
  searchControl = new FormControl("");
  invoiceData: any = {};
  loadingContract = false;

  constructor(
    private route: ActivatedRoute,
    private invoiceService: InvoiceService,
    private notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      const contractNo = params.get("contractno")?.trim();
      if (!contractNo) return;

      this.searchControl.setValue(contractNo, { emitEvent: false });
      this.loadContract(contractNo);
    });
  }

  loadContract(value: string | null = this.searchControl.value): void {
    const contractNo = String(value ?? "").trim();
    if (!contractNo) {
      this.notifier.notify("error", "Enter a contract number to search.");
      return;
    }

    this.loadingContract = true;
    this.invoiceService.getDetailsByContractNo(contractNo).subscribe({
      next: (response) => {
        if (response?.statusCode !== 200 || (response?.code !== undefined && response.code !== 0)) {
          this.invoiceData = {};
          this.notifier.notify("error", response?.message || "Contract details could not be loaded.");
          this.loadingContract = false;
          return;
        }

        this.invoiceData = response.body ?? {};
        this.invoiceService.getEnableButton(contractNo).subscribe({
          next: (buttonResponse) => {
            if (buttonResponse?.statusCode === 200 && buttonResponse.body) {
              this.invoiceData = { ...this.invoiceData, ...buttonResponse.body };
            }
            this.loadingContract = false;
          },
          error: () => {
            this.loadingContract = false;
            this.notifier.notify("error", "Contract loaded, but invoice options could not be retrieved.");
          },
        });
      },
      error: (error) => {
        this.invoiceData = {};
        this.loadingContract = false;
        this.notifier.notify("error", error?.message || "Contract details could not be loaded.");
      },
    });
  }

  dateInput(value: string | null | undefined): string {
    if (!value) return "";
    const parts = value.split("/");
    return parts.length === 3 ? `${parts[2]}-${parts[1]}-${parts[0]}` : value;
  }

  updateDate(field: string, value: string): void {
    if (!value) {
      this.invoiceData[field] = "";
      return;
    }
    const [year, month, day] = value.split("-");
    this.invoiceData[field] = `${day}/${month}/${year}`;
  }

}
